import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      limitingRisk: boolean(Joi).label(
        labeled(label, 'from potential future decreases in the interest rate')
      ),
      retainingDegree: boolean(Joi).label(
        labeled(
          label,
          'Retaining a degree of flexibility in relation to increased repayments, redraws and/or early repayment of part of the loan'
        )
      ),
      easierBudgeting: boolean(Joi).label(
        labeled(label, 'Make budgeting easier than if the entire loan were variable')
      ),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue('limitingRisk', 'retainingDegree', 'easierBudgeting', 'other')
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
